import { EventRequest, Global } from 'types';
import { prettyDateTime } from '@utils/dates';

export const EMPTY = 'N/A';

const byDate = (a: string, b: string): number => (new Date(a).getTime() - new Date(b).getTime());

interface Model { updated_at?: string }

const getUpdatedAtFromModels = <M extends Model> (list?: M[]): string[] => (
  !list?.length ? [] : list.map(({ updated_at: updatedAt = '' }) => updatedAt)
);

const getUpdatedAtFromFields = <T extends Model, F extends keyof T> (model: T, fields?: F[]): string[] => (
  !fields?.length ? [] : fields.map((field: F): string[] => (
    getUpdatedAtFromModels(model[field] as Model[])
  )).flat()
);

const getUpdatedAtSubModels = <T extends Model, F extends keyof T> (list?: T[], fields?: F[]): string[] => (
  !list?.length ? [] : list.map((model: T): string[] => [
    ...getUpdatedAtFromFields(model, fields),
    model.updated_at || ''
  ]).flat()
);

const getRequestUpdatedAt = ({ updated_at: updatedAt = '', lots }: Partial<EventRequest>): string[] => (
  [...getUpdatedAtSubModels(lots, ['line_items', 'custom_column_headers']), updatedAt]
);

const getLastUpdated = (request: Partial<EventRequest>): string => {
  const list: string[] = getRequestUpdatedAt(request).filter(Boolean);

  return !list?.length ? '' : list.sort(byDate)[list.length - 1];
};

export const getLastEdited = (request: Partial<EventRequest>, global: Global, userDatePartOrder: string): string => {
  const lastUpdated = getLastUpdated(request);

  if (!lastUpdated?.length) return EMPTY;

  // TLC: We should look at getting away from Moment: https://arkestrodev.atlassian.net/browse/PEPBACKLOG-1313.
  return prettyDateTime(lastUpdated, userDatePartOrder, global, 'shortSlashDateWithLongYear', 'hoursMinutesMeridiemWithTimezone');
};
